
<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <v-row>
        <v-col md="2">
          <ModuleHeader>Membresias</ModuleHeader>
        </v-col>
        <v-col md="10" class="text-right">
          <v-btn color="green" elevation="0" dark @click="exportExcel"><v-icon>mdi-file-excel-box</v-icon> Exportar a Excel</v-btn>
          <!-- <download-excel class="exportExcel"  type="xls" name="Membresias.xls" :data="excelData">
          </download-excel> -->
        </v-col>
      </v-row>
      <uv-data-table
        :config="config"
        :data="dataMembresias"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <v-dialog
      v-model="Dialogs.sync"
      persistent
      max-width="390"
    >
      <v-card>
        <v-card-title class="text-h5">
          Sincronización de datos
        </v-card-title>
        <v-card-text>Enviar actualización a los dispositivos Biometricos
          configurados en la red.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="Dialogs.sync = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="syncBiometric();"
          >
            Enviar Sincronización
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal ref="modalForm" :fullscreen="true" v-model="Dialogs.showModal" :showFooter="false">
      <MembresiasForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      />
    </modal>
  </div>
</template>



<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import modal from "../../MainComponents/modal.vue";
import MembresiasForm from "../../Membresias/Membresias/MembresiaForm.vue";
import Membresia from "../../../clases/Membresias/Membresia.js";
import MembresiaPlan from "../../../clases/Membresias/MembresiaPlan.js";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "MembresiasCRUD",
  components: {
    uvDataTable,
    MembresiasForm,
    modal,
  },
  data() {
    return {
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      Dialogs:{
        sync:false,
        showModal: false,
      },
      config: {
        selectableRow: true,
        orderByCol:{Field:"NumeroMembresia",Type:"Asc"},
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addMembresia",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarMembresia",
            require: true,
          },
          {
            text: "Detalle Membresia",
            icon: "lni lni-pencil-alt",
            buttonId: "detalleMembresias",
            require: true,
          },
          {
            text: "Desactivar Membresia",
            icon: "lni lni-trash",
            buttonId: "softDeleteMembresias",
            require: true,
          },
          {
            text: "Enviar Sinc. Biometrica",
            icon: "lni lni-trash",
            buttonId: "syncMembresias",
            require: true,
          },
        ],
        fields: [
          {
            title: "Plan Membresia",
            text:'Plan Membresia',
            value:'PlanName',
            dataName: "PlanName",
            canBeFiltered: true,
          },
          {
            title: "Numero de membresia",
            dataName: "NumeroMembresia",
            text:'Numero de membresia',
            value:'code',
            format: (row) => {
              if(row['Code'].Pre){
                return row['Code'].Pre + '-' + row['Code'].Pos;
              }else{
                return "Membresia no existente"
              }
              
            }
          },
          {
            title: "Titular",
            text:'Titular',
            value:'TitularName',
            dataName: "TitularName",
          },
          {
            value:'NombrePeriodo',
            text: "Periodo Pago",
            canBeFiltered: true,
          },
          {
            text:'Deuda Actual',
            value: "Deuda",
            format: (row) => {
              let deuda = parseFloat(row.Deuda.C).toFixed(2);
              if(row.Deuda.C > 0){
                return "<b class='red--text'>"+ this.$pgsHelper.formatNumber(deuda)  +' '+row.Deuda.M + "</b>";
              }else{
                return `<b class='green--text'>`+this.$pgsHelper.formatNumber((deuda * -1))  +' '+row.Deuda.M + `</b>`+
                ((row.Deuda.C != 0)?`<br/>
                <p style="font-size: 10px; margin-bottom:0px">Saldo a favor</p>`:``);
              }
            }
          },
          {
            title: "Miembros",
            dataName: "Clientes",
            text:'Miembros',
            value: "Clientes",
            format: (row) => {
              return Object.keys(row["Clientes"]).length;
            }
          },
        ],
      },
      Catalogos:{
        PlanesMembresias:[],
        data_membresias:[],
      },
      aux:{
        membresiaToSync:{},
      },

    };
  },
  computed: {
    clients() {
      return this.$store.getters.getClientes.reduce((acc, client) => {
        if (client.id !== "PUBLICOGENERAL") {
          acc[client.id] = client;
        }
        return acc;
      }, {});
    },
    dataMembresias() {
      const rawMembresias = Membresia.getMembresiasList();
      const allClients = this.clients;
      
      // Mapas de búsqueda rápida O(1) para evitar recorridos O(N) dentro del loop
      const planesMap = new Map(this.PlanesMembresias.map(p => [p.Id, p]));
      const periodosMap = new Map(PeriodosCobro.getPeriodosCobroList().map(p => [p.Id, p]));

      return rawMembresias.map(element => {
        const titular = allClients[element.Titular];
        const plan = planesMap.get(element.Plan);
        const periodo = periodosMap.get(element.Periodo);

        // Pre-formateo de campos para el datatable
        element.code = `${element.Code?.Pre || ''}${element.Code?.Pos || ''}`;
        element.NumeroMembresia = element.Code?.Pos;
        element.PlanName = plan?.Nomb || 'Sin Plan';
        element.NombrePeriodo = periodo?.Nombre || 'N/A';
        element.Apodo = titular?.Apodo || '';
        
        element.TitularName = titular 
          ? `${titular.Nombres} ${titular.Apellidos}${titular.Apodo ? ` (${titular.Apodo})` : ''}`
          : 'Sin titular';

        return element;
      });
    },
    excelData(){
      let data = [];
      this.dataMembresias.forEach((m)=>{
        data.push({
          NumeroMembresia:m.code,
          Alias:m?.Apodo,
          Codigo:m?.Code?.Pos,
          Plan:m.PlanName,
          Titular:m.TitularName,
          Periodo:m.NombrePeriodo,
          Estatus:(m.Activo)?'ACTIVO':'INANCITVO',
          Deuda:parseFloat(m.Deuda.C).toFixed(2),
          Moneda:m.Deuda.M,
          Miembros:Object.keys(m.Clientes).length
        });
      })
      return data;
    },
    PlanesMembresias(){
      let PlanesMembresias  = MembresiaPlan.getMembresiasPlanList();
      return PlanesMembresias;
    }
  },
  methods: {
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Membresias.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createMembresia(data);
      } else if (doAction == "EDIT") {
        this.editarMembresia(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addMembresia") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Membresia");
        this.clientAdd = {
          nombre: "",
          apellidos: "",
          correo: "",
          telefono: "",
          grupo: "",
        };
        this.toggleModal(true);
      }
      if (buttonId == "editarMembresia") {
        this.idSelected = idSelected[0];
        const membresia = this.$pgsHelper.getById(
          this.dataMembresias,
          "Id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = membresia;
        this.$refs.modalForm.setTitle("Editar Membresia");
        this.toggleModal(true);
      }
      if(buttonId =='detalleMembresias'){
        this.$router.push({ path: "detalleMembresias/"+idSelected[0] });
      }
      if (buttonId == "softDeleteMembresias") {
        this.softDeleteMembresias(idSelected[0]);
      }
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    syncBiometric(){
      this.aux.membresiaToSync;
      this.Dialogs.sync = false;
    },
    createMembresia(data) {
      console.log(data);
      data.DiasProrroga = Number(data.DiasProrroga);
      this.$swal({
        title: "¿Deseas guardar la membresia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Membresias-createMembresia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La membresia se guardo correctamente",
              icon: "success",
            }).then(async() => {
              //this.Dialogs.sync = true;
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving membresia",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editarMembresia(data) {
      this.$swal({
        title: "¿Deseas guardar la información de membresia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Membresias-updateMembresia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El plan de membresia se guardo correctamente",
              icon: "success",
            }).then(async() => {
              //this.Dialogs.sync = true;
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving plan membresia",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    softDeleteMembresias(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas desactivar la membresia?",
        text: "Se eliminaran los clientes y titular de la memebresia selecionada",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Membresias-deleteMembresia", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then( async(result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("El plan de membresia se elimino correctamente", "", "success");
            //this.Catalogos.data_membresias = await Membresia.getMembresiasList();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.Dialogs.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    /*this.Catalogos.data_membresias = await Membresia.getMembresiasList();
    this.Catalogos.data_membresias.forEach((element)=>{
      element.NumeroMembresia = element?.Code?.Pos;
      element.TitularName = this.$pgsHelper.getById(this.comp_clients,'id',element.Titular);
    })*/
    this.Catalogos.PlanesMembresias  = await MembresiaPlan.getMembresiasPlanList();
  },
};
</script>
<style scoped>
  .exportExcel{
    width: fit-content !important;
    position: absolute !important;
    right: 10px;
  }
</style>




